import { frontendURL } from '../../../helper/URLHelper';

import Katalog from './Katalog.vue';
import KatalogUrunler from './KatalogUrunler.vue';
import KatalogMeta from './KatalogMeta.vue';
import KatalogAktarim from './KatalogAktarim.vue';
import KatalogApi from './KatalogApi.vue';

// Katalog yalnizca yoneticiye acik. Yazma uclari zaten sunucuda yoneticiye
// kilitli; temsilciye sayfayi acmak 401 alan dugmeler gostermek olurdu.
// Temsilcinin urunlere erisimi asistan uzerinden zaten var.
const YETKI = { permissions: ['administrator'] };

export const routes = [
  {
    path: frontendURL('accounts/:accountId/katalog'),
    component: Katalog,
    meta: YETKI,
    // Bos kabuk yerine dogrudan urun listesine.
    redirect: () => ({ name: 'katalog_urunler' }),
    children: [
      { path: 'urunler', name: 'katalog_urunler', component: KatalogUrunler, meta: YETKI },
      { path: 'meta', name: 'katalog_meta', component: KatalogMeta, meta: YETKI },
      { path: 'aktarim', name: 'katalog_aktarim', component: KatalogAktarim, meta: YETKI },
      { path: 'api', name: 'katalog_api', component: KatalogApi, meta: YETKI },
    ],
  },
];
